import React, {useEffect} from 'react';
import Alert from "react-bootstrap/Alert";
import Pages from "../components/layout/Pages";
import {concepts} from "fearless-common";
import {Button} from "fearless-common-ui";
import Header from "../components/Header";
import {routes} from "../utils";
import Description from "../components/Description";
import StandardIcons from "../components/layout/StandardIcons";
import {externalLinks} from "../utils/routes";
import {useSearchParams} from "react-router-dom";
import photo51logo from "../assets/images/logos/photo51-blue-desktop-icon.svg";


// Open Photo51 on desktop
export function openPhoto51DesktopApplication() {
    window.location.href = externalLinks.photo51desktop;
}


export const OpenPhoto51SearchFlags = {
    SHARE_REQUEST_ACCESS_LINK: 'share-request-access-link'
}

/**
 * Page that opens the Photo51 desktop application from the website.
 * Similar to Microsoft Teams, when you have received a team link, you have the option to
 * open MS teams on application.
 *
 * @constructor
 */
export default function OpenPhoto51() {
    useEffect(() => {
        // delay opening the desktop application just a little, because it breaks the E2E tests.
        // With a small timeout, the E2E test can quickly move on.
        setTimeout(() => openPhoto51DesktopApplication(), 500);
    }, []);

    const [searchParams] = useSearchParams();

    return (
      <div className="bg-neutral-100">
          <Pages.Centred width="xs" className="text-center" padded={false} verticalAlignCenter>
            <div className="bg-white border border-neutral-300 p-5" style={{ borderRadius: 10, borderWidth: '0.5px' }}>
              <img src={photo51logo} height={80} alt={`${concepts.Photo51} logo`} />
              <Header component="h1" className="gradient-color mb-3 mt-3 h2">Opening {concepts.Photo51}</Header>
              {searchParams.has(OpenPhoto51SearchFlags.SHARE_REQUEST_ACCESS_LINK) && (
                  <Alert variant="success">Your files are in your {concepts.Photo51} share requests inbox.</Alert>
              )}
              <Description className="text-sm">
                  If the application does not open by itself, please use the button below.
              </Description>

              <a href={externalLinks.photo51desktop} className="text-decoration-none">
                  <Button className="d-block w-100 text-center rounded-1 shadow" size="lg">Open {concepts.Photo51} desktop</Button>
              </a>
              <div className="my-3" />
              <a href={routes.photo51Cloud} className="text-decoration-none">
                  <Button variant="outline-secondary" size="lg" className="d-block w-100 shadow rounded-1" icon={<StandardIcons.Cloud width={20} />}>
                      Open {concepts.Photo51} cloud
                  </Button>
              </a>
            </div>
          </Pages.Centred>
      </div>
    );
}
